export interface IUser {
  id?: string // firestore id
  email: string
  isAdmin: boolean
}

export class User implements IUser {
  public readonly id: string
  public readonly email: string
  public readonly isAdmin: boolean
  constructor({
    id = '',
    email = '',
    isAdmin = false,
  }) {
    this.id = id
    this.email = email,
    this.isAdmin = isAdmin
  }

  public toObject(): IUser {
    return {
      id: this.id,
      email: this.email,
      isAdmin: this.isAdmin
    }
  }
}
